class BtnToggle extends HTMLElement {
  connectedCallback() {
    this.img = document.querySelector('.meal-recommend__img');
    this.thumbEl = this.querySelector('.js-toggle-thumb');
    this.leftLabel = this.querySelector('.js-toggle-left');
    this.rightLabel = this.querySelector('.js-toggle-right');
    this.leftInput = this.leftLabel.querySelector('input');
    this.rightInput = this.rightLabel.querySelector('input');

    this.suppressTrigger = false;

    this.leftLabel.addEventListener('click', () => {
      this.setState('left');
    });

    this.rightLabel.addEventListener('click', () => {
      this.setState('right');
    });
  }

  setState(side) {
    if (side === 'left') {
      this.dataset.flavor = 'chicken';
      this.thumbEl.style.transform = 'translateX(0)';
      this.leftInput.checked = true;
      if (this.img) this.img.src = 'https://cdn.shopify.com/s/files/1/0015/5919/9790/files/FFD_Overhead_Bowl_-_Chicken_263c93c8-aaed-491c-b5b2-0f59d92c540f.png?v=1754919562';

      if (!this.suppressTrigger) {
        this.onToggleChange(this.leftInput.value);
      }
    } else {
      this.dataset.flavor = 'beef';
      this.thumbEl.style.transform = 'translateX(100%)';
      this.rightInput.checked = true;
      if (this.img) this.img.src = 'https://cdn.shopify.com/s/files/1/0015/5919/9790/files/FFD_Overhead_Bowl_-_Beef_73377e5a-aa04-4eb7-b3b5-6087e777ab82.png?v=1754919562';

      if (!this.suppressTrigger) {
        this.onToggleChange(this.rightInput.value);
      }
    }

    this.suppressTrigger = false;
  }

  onToggleChange(value) {
    if (
      value &&
      flavorObjects &&
      flavorObjects[value] &&
      flavorObjects[value][1]
    ) {
      let variantId = flavorObjects[value][1];
      toggledFlavor = value;
      toggledVariant = variantId;
    }

    const selectedPetId = localStorage.getItem('selectedPet');
    const petObject = getPetData(selectedPetId);

    if (petObject.ffdFlavor !== value) {
      petObject.ffdFlavor = value;
      petObject.ffdVariantId = flavorObjects[value][1];

      const petProfiles = JSON.parse(
        localStorage.getItem('petProfiles') || '{"pets":[]}'
      );
      const petIndex = petProfiles.pets.findIndex(
        (pet) => pet.id === selectedPetId
      );
      if (petIndex !== -1) {
        petProfiles.pets[petIndex] = petObject;
        localStorage.setItem('petProfiles', JSON.stringify(petProfiles));
      }

      // Apply flavor to product form
      if (typeof updateFlavorVariant === 'function') {
        updateFlavorVariant(value);
      }
    }

    return;
  }
}

if (!customElements.get('btn-toggle')) {
  customElements.define('btn-toggle', BtnToggle);
}
